// extracted by mini-css-extract-plugin
module.exports = {"pricesCard":"PricesCard_pricesCard__FYiYB","card":"PricesCard_card__kR0RV","titleCard":"PricesCard_titleCard__1OXma"};